import { CSSProperties, FC, ReactElement } from 'react';

import { useLocation } from 'react-router-dom';

import { AppRoute, appRoutes } from '../../entities/Routing/Routing';
import { useTrans } from '../../hooks';
import { CheckoutNavigationItem } from './subcomponents';

import './CheckoutNavigation.scss';

interface CheckoutNavigationProps {
    className?: string;
}

export const CheckoutNavigation: FC<CheckoutNavigationProps> = ({
    className = '',
}): ReactElement => {
    const trans = useTrans();
    const location = useLocation();

    const currentStep = location.pathname;

    const navigationItems = [
        {
            id: 1,
            route: appRoutes[AppRoute.checkoutOrder],
        },
        {
            id: 2,
            route: appRoutes[AppRoute.checkoutDetails],
        },
        {
            id: 3,
            route: appRoutes[AppRoute.checkoutPayment],
        },
    ];

    const items = navigationItems.map((item, index) => ({
        ...item,
        link: {
            label: trans(item.route.label),
            href: trans(item.route.path),
        },
        stepIndex: index + 1,
    }));

    const activeItem = items.find(item => {
        const routePath = trans(item.route.path);

        return routePath === currentStep;
    });

    const activeIndex = activeItem
        ? activeItem.stepIndex
        : 1;

    const cssVariables = {
        '--checkout-navigation-progress-percentage': `${((activeIndex - 1) / (items.length - 1)) * 100}%`,
    } as CSSProperties;

    return (
        <nav
            aria-label={trans('containers.checkoutNavigation.navigationLabel')}
            style={cssVariables}
            className={`checkout-navigation ${className}`}
        >
            <ol className="checkout-navigation__list">
                {items.map(item => (
                    <CheckoutNavigationItem
                        key={item.id}
                        stepIndex={item.stepIndex}
                        activeIndex={activeIndex}
                        to={item.link.href}
                        label={item.link.label}
                    />
                ))}
            </ol>
        </nav>
    );
};
